export const HOST = '//music-api.lilnong.top'
export const ERR_OK = 200

export const playMode = {
  sequence: 0,
  loop: 1,
  random: 2
}



// WEBPACK FOOTER //
// ./src/common/js/config.js